import { render } from "./ButhiMain.vue?vue&type=template&id=27c16b9a&scoped=true"
import script from "./ButhiMain.vue?vue&type=script&lang=js"
export * from "./ButhiMain.vue?vue&type=script&lang=js"

import "./ButhiMain.vue?vue&type=style&index=0&id=27c16b9a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wkphi\\Desktop\\Programming\\buthigame - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c16b9a"]])

export default __exports__